<template>
  <div class="text--primary">
    <v-row>
      <v-col cols="12">
        <px-config-notificacoes-lista :config-notificacoes="configNotificacoes"
                                      :options-list="optionsList"
                                      :loading="loadingNots"
                                      @update="onUpdate"/>
      </v-col>
    </v-row>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>
<script>
import paginationMixin from '@/mixins/pagination-mixin';
import ConfigNotificacoesLista from '../notificacao/ConfigNotificacoesLista.vue';
import NotificacaoService from '../notificacao/config-notificacao-service';
import { buildNotificacoes } from '../notificacao/notificacao-utils';

export default {
  props: {
    user: Object,
    loading: Boolean,
  },
  mixins: [paginationMixin],
  data() {
    return {
      loadingNots: this.loading,
      configNotificacoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: `usuario.id = ${this.user.id}`,
        sort: 'notificacao',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  methods: {
    getNotificacoes() {
      this.loadingNots = true;

      const { limit, offset } = this.listOptions;

      NotificacaoService.getList({
        query: this.buildQuery(this.listOptions),
        limit,
        offset,
      })
        .then((response) => {
          this.configNotificacoes = buildNotificacoes(response.data, this.user);
        })
        .finally(() => {
          this.loadingNots = false;
        });
    },
    onUpdate() {
      this.getNotificacoes();
    },
  },
  components: {
    pxConfigNotificacoesLista: ConfigNotificacoesLista,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.getNotificacoes();
  },
};
</script>
